import { render, staticRenderFns } from "./see-channel.pug?vue&type=template&id=448790c1&lang=pug&"
import script from "./see-channel.ts?vue&type=script&lang=ts&"
export * from "./see-channel.ts?vue&type=script&lang=ts&"
import style0 from "./see-channel.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports